import { Monitor } from "lucide-react";

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { MOBILE_BREAKPOINT } from "@/hooks/use-mobile";

export const MobileViewportDialog = () => {
  const handlePreventClose = (event: Event) => {
    event.preventDefault();
  };

  return (
    <Dialog open modal>
      <DialogContent
        className="w-[calc(100%-2rem)] max-w-md gap-0 overflow-hidden border-border bg-card p-0 shadow-lg [&>button]:hidden"
        onEscapeKeyDown={handlePreventClose}
        onInteractOutside={handlePreventClose}
        onPointerDownOutside={handlePreventClose}
      >
        <DialogHeader className="border-b border-border p-6 pb-4 text-left">
          <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-xl border border-primary/20 bg-primary/10 text-primary">
            <Monitor className="h-6 w-6" />
          </div>
          <DialogTitle>Screen too small</DialogTitle>
          <DialogDescription className="pt-2 text-sm text-muted-foreground">
            This app is not available on phone-sized screens. Please switch to a
            tablet or laptop screen, or widen this window to continue.
          </DialogDescription>
        </DialogHeader>
        <div className="p-6 pt-5 text-sm text-muted-foreground">
          Minimum supported width: {MOBILE_BREAKPOINT}px.
        </div>
      </DialogContent>
    </Dialog>
  );
};
